export default __webpack_public_path__ + "static/pharmacyAisle-218889de6dcf4fafd52ef19ab8de60b6.svg";